module.exports = __webpack_public_path__ + "img/footer_illustration_center.94418627.svg";